import { format } from 'date-fns';

export function formatDateTimezoneOffsetHotfix(date: Date): string {
    // Hot fix: strip time out of date due to faulty time zones offsets
    // See: https://schuettflix.grafana.net/a/grafana-irm-app/incidents/125/
    //
    // This hotfix works because the input date is UTC and `format` converts it back to the date and time of the locale.
    // However, this is a one way fix, because when `2025-10-02` ids coerced to a date it becomes `2025-10-02T00:00:00.000Z`.
    // This means if you convert that that back to a LOCALIZED date the time shifts accordingly?
    // > new Date(`2025-10-02T00:00:00.000Z`).toLocaleString('de-DE') => '2.10.2025, 02:00:00'
    // The implication is, that as long as you are in UTC+x the day is correct. UTC-x ends up on the prior day.
    // > new Date(`2025-10-02T00:00:00.000Z`).toLocaleString('de-DE', { timeZone: 'America/Chicago' }) => '1.10.2025, 19:00:00'
    //
    // For format details see: https://date-fns.org/v4.1.0/docs/format
    return `${format(date, 'yyyy-MM-dd')}`;
}
